"use strict";

exports.__esModule = true;
exports.AppList = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _App = require("../App");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AppListWrapper = _styledComponents["default"].div.attrs({
  className: "app-list-wrapper"
}).withConfig({
  displayName: "AppList__AppListWrapper",
  componentId: "sc-11888u5-0"
})(["display:flex;flex-wrap:wrap;justify-content:center;margin-top:20px;margin:auto;"]);
var AppList = exports.AppList = function AppList(_ref) {
  var appsList = _ref.appsList;
  return /*#__PURE__*/_react["default"].createElement(AppListWrapper, null, appsList.map(function (app) {
    return /*#__PURE__*/_react["default"].createElement(_App.App, {
      key: app.id,
      id: app.id,
      defaultName: app.defaultName,
      screenName: app.screenName,
      icon: app.icon,
      externalUrl: app.externalUrl,
      permission: app.permission
    });
  }));
};